<template>
  <div  >

    <!-- Default mode (existing dropdown) -->
    <dropdown  v-if="showHideDropdown && !isAccordion" :class="`filter filter-dropdown ${config.name}`" v-bind="config.attrs">
      <template #btn>
        <span>{{ buttonCaption }}</span>
        <config-style-injector
          :config="config"
          :root-selector="`.filter-dropdown.${config.name}`"
        />
      </template>

     <template #body>
  	<div v-for="section in sections" :key="section.title">

    <!-- BrandDescriptions -->
    <div v-if="isCTC && section.id === 'BrandDescriptions'" class="brand-virtual">
     <div class="brand-search-row">
  <input
    v-model="brandSearch"
    class="brand-search brand-search--desktop"
    type="text"
    :placeholder="content.searchBrands"
  />
  <clear-filter-button :on-click="clearBrandSearch"/>
</div>
     <!-- small list → NO virtual scroll -->
<div
  v-if="section.items.length <= 5"
  class="brand-scroller simple"
>
  <AdvTitledList
    :enable-toggle-all="false"
    :items="section.items"
    :title="null"
    @select="onFilterToggle($event, section.id)"
  />
</div>

<!-- large list → virtual scroll -->
<RecycleScroller
  v-else
  class="brand-scroller"
  :items="section.items"
  :item-size="32"
  key-field="__key"
  v-slot="{ item }"
>
  <AdvTitledList
    :enable-toggle-all="false"
    :items="[item]"
    :title="null"
    @select="onFilterToggle($event, section.id)"
  />
</RecycleScroller>
    </div>

    <!-- Other sections -->
    <adv-titled-list
      v-else
      :enable-toggle-all="!!section.enableToggleAll"
      :items="section.items"
      :title="section.title"
      @select="onFilterToggle"
    />

 	 </div>
	</template>
  </dropdown>

   <!-- CTC Accordion mode -->
<div v-if="showHideDropdown && isAccordion" :class="`filter-accordion ${config.name}`">
  <div v-for="section in sections" :key="section.id ">
    <!-- Header -->
    <div
      class="filter-accordion__header"
      role="button"
      tabindex="0"
      @click="toggleAccordion(section.id)"
      @keyup.enter="toggleAccordion(section.id)"
      @keydown.space.prevent="toggleAccordion(section.id)"
    >
      <span class="filter-accordion__title">{{ buttonCaption }}</span>
      <span class="sr-only">, </span>
      <span class="filter-accordion__icon" :aria-label="sectionAriaLabel(section)"> {{ isSectionOpen(section.id) ? '−' : '+' }}</span>
    </div>

    <!-- Body -->
    <div v-if="isSectionOpen(section.id)" class="filter-accordion__body">
      <!-- BrandDescriptions -->
      <div v-if="section.id === 'BrandDescriptions'" class="brand-virtual">
        <div class="brand-search-row brand-search-row--mobile">
  <input
    v-model="brandSearch"
    class="brand-search brand-search--mobile"
    type="text"
    :placeholder="content.searchBrands"
  />
  <clear-filter-button :on-click="clearBrandSearch"/>
</div>
 

<RecycleScroller
  
  class="brand-scroller"
   :style="{ height: `${Math.min(section.items.length * 32, 260)}px` }"
  :items="section.items"
  :item-size="32"
  key-field="__key"
  v-slot="{ item }"
>
  <AdvTitledList
    :enable-toggle-all="false"
    :items="[item]"
    :title="null"
    @select="onFilterToggle($event, section.id)"
  />
</RecycleScroller>
      </div>

      <!-- Other sections -->
      <adv-titled-list
        v-else
        :enable-toggle-all="!!section.enableToggleAll"
        :items="section.items"
        :title="null"
        @select="onFilterToggle($event, section.id)"
      />
    </div>
  </div>
</div>


 </div>
</template>


<script>
import Dropdown from "@/components/bp-vuejs-dropdown/Dropdown.vue"
import AdvTitledList from "@/components/lists/AdvTitledList.vue";
import featureMixin from "@/mixins/featureMixin";
import ConfigStyleInjector from "@/components/style-injector/ConfigStyleInjector.vue";
import {mapActions, mapGetters, mapState} from "vuex";
import { RecycleScroller } from "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import ClearFilterButton from "@/features/filters/buttons/ClearFilterButton.vue";

function handleFilterType(fType, qo, sid, item, selected = false) {
	switch (fType) {
		case 'boolean':
			qo[item.id || item.label] = selected;
			break;
		case 'single':
			if (selected) {
				qo[sid] = item.value || item.label
			} else {
				qo[sid] = '';
			}
			break;
		default:
			if (!qo[sid]) {
				qo[sid] = [];
			}
			if (selected) qo[sid].push(item.value || item.label)
	}
}

export default {
	name: "FilterDropdown",
	mixins: [featureMixin],
	components: {ConfigStyleInjector, AdvTitledList, Dropdown,RecycleScroller, ClearFilterButton},
	props: {
		label: {
			type: String
		},
		filterName: {
			type: String,
			default: 'categories'
		}
	},
	data() {
		return { brandSearch: '', cachedAvailableBrands: [] }
	},
	computed: {
    ...mapGetters('filters',['hasMadeInCanadaOrQuebecProducts','hasLoyaltyProducts','activeAccordionSections','filtersClearedAt']),
    ...mapGetters('filters',['hasMadeInCanadaOrQuebecProducts','hasLoyaltyProducts','activeAccordionSections','filtersClearedAt']),
	   ...mapGetters('landingPage', ['currentFlyer']),
	   ...mapGetters(['isCTC']),
	   ...mapGetters('search', ['availableBrands','showSearchResults']),
	   ...mapState('search', ['BrandDescriptions']),
		showHideDropdown() {
			
		const validDropdownValues = ['category','waysToSave','Metro&Moi','brand','saving','HealthyChoices','gender','pricing','offer']
		if (this.currentFlyer?.title === 'SBYDEMOWK26') {
		return (
		this.config.name !== 'HealthyChoices' &&
		(validDropdownValues.includes(this.config.name) ||
			(this.config.name === 'localProducts' && this.hasMadeInCanadaOrQuebecProducts) ||
			(this.config.name === 'loyalty' && this.hasLoyaltyProducts))
		);
	}

	return (
		validDropdownValues.includes(this.config.name) ||
		(this.config.name === 'localProducts' && this.hasMadeInCanadaOrQuebecProducts) ||
		(this.config.name === 'loyalty' && this.hasLoyaltyProducts)
	);
		// return validDropdownValues.includes(this.config.name) || (this.config.name === 'localProducts'  && this.hasMadeInCanadaOrQuebecProducts)
		},

			sections() {
			const sections =this._config.sections || [];

			return sections.map(section => {
				let resolvedSection = section;

				//  Resolve __self.content.* titles (missing in your code)
				if (
				resolvedSection.title &&
				typeof resolvedSection.title === 'string' &&
				resolvedSection.title.startsWith('__self.content.')
				) {
				const key = resolvedSection.title.replace('__self.content.', '');
				resolvedSection = {
					...resolvedSection,
					title: this.content?.[key] || resolvedSection.title
				};
				}

				//  BrandDescriptions-specific logic (your addition)
				if (resolvedSection.id !== 'BrandDescriptions') {
				return resolvedSection;
				}

				const withKeys = (resolvedSection.items || []).map((i, idx) => ({
				...i,
				__key: `${(i.label ?? 'brand')}-${idx}`
				}));

				const searchFiltered = this.cachedAvailableBrands.length > 0
				? withKeys.filter(i => this.cachedAvailableBrands.includes(i.label) || this.cachedAvailableBrands.includes(i.value))
				: withKeys;

				const q = (this.brandSearch || '').trim().toLowerCase();
				const filtered = !q
				? searchFiltered
				: searchFiltered.filter(i => ((i.label ?? i.value ?? '') + '').toLowerCase().includes(q));

				return {
				...resolvedSection,
				items: filtered
				};
			});
			},
		buttonCaption() {
			const label = this._config?.label || this.config?.label || this.label;
			// If label still contains __self, try to resolve it manually
			if (label && typeof label === 'string' && label.startsWith('__self.content.')) {
				const key = label.replace('__self.content.', '');
				return this.content?.[key] || label;
			}
			return label;
		},
		isAccordion() {
		return this.config?.attrs?.view === 'accordion';
		},
		value() {
			const v = {};
			this.sections.forEach((section) => {
				const sid = section.id;
				const format = section?.format ?? 'array';
				section.items.forEach((item) => {
					handleFilterType(format, v, sid, item, item.checkbox.selected);
					/*if (item.checkbox.selected) {
											switch (format) {
												case 'boolean':
													v[item.id || item.label] = true;
												break;
												case 'single':
													v[sid] = item.value || item.label
												break;
												default:
													if(!v[sid]) {
														v[sid] = [];
													}
													v[sid].push(item.value || item.label)
											}
										}*/
				});
			})
			console.log('Filter Value Changed:', v);
			return v;
		},
		 isSectionOpen() {
		return sectionId =>
			Array.isArray(this.activeAccordionSections) &&
			this.activeAccordionSections.includes(sectionId);
		}
	},

	methods: {
		...mapActions('events', ['triggerEvent']),
		 ...mapActions('filters', ['openAccordionSection','closeAccordionSection','clearBrandDescriptions','clearBrandsNotIn']),
		

		toggleAccordion(sectionId) {
			if (this.isSectionOpen(sectionId)) {
			this.closeAccordionSection(sectionId);
			} else {
			this.openAccordionSection(sectionId);
			}
		},
		sectionAriaLabel(section) {
			const caption = this.buttonCaption || '';
			const phrase = this.isSectionOpen(section.id) ? this.content.collapseOptionsAbout : this.content.expandOptionsAbout;
			return `${phrase} ${caption}`;
		},
		onFilterToggle(f, sectionId) {
			this.openAccordionSection(sectionId);

			this.triggerEvent({
				event: `filter-toggle-event-${this.config.name}`,
				data: f
			});
			console.log('Filter Toggle:', f, ' Value:', this.value);

			//	this.updateQuery(this.value);
		},
		clearBrandSearch() {
			const openedSections = [...this.activeAccordionSections];

			this.clearBrandDescriptions();
			this.brandSearch = '';

			this.$nextTick(() => {
				setTimeout(() => {
				openedSections.forEach(sectionId => {
					this.openAccordionSection(sectionId);
				});
				}, 10);
			});
		}
	},

	watch: {
		availableBrands: {
  		immediate: true,
  		handler(newVal = []) {
    		const selectedBrands = this.BrandDescriptions || [];

    if (!selectedBrands.length) {
      this.cachedAvailableBrands = [...newVal];
      return;
    }

    const allSelectedStillAvailable = selectedBrands.every(brand =>
      newVal.includes(brand)
    );

    if (allSelectedStillAvailable) {
      this.cachedAvailableBrands = [
        ...new Set([...selectedBrands, ...newVal])
      ];
    } else {
      this.$store.commit('search/SET_LOADING', true);
      this.clearBrandsNotIn(newVal);
      this.cachedAvailableBrands = [...newVal];
    }
  }
},
		filtersClearedAt() {
			this.brandSearch = '';
		}
	},
	
	
}
</script>
<style scoped></style>
<style lang="scss">

[mode='tablet'], [mode='mobile'] {
  .filter-dropdown {
	.bp-dropdown__body {
	  max-height: calc(100vh - 200px); /* tune this */
      overflow-y: auto;
	}
  }
}
[mode='tablet'] {
	.filter-dropdown {
		flex-basis: 20%;
	}
}

[mode='mobile'] {
	.filter-dropdown {
		flex-basis: 47%;
		max-width: unset !important;
    height: 100%;
	}

  .brand-search-row--mobile {
    padding: 0 12px;
  }

  .filter-accordion .brand-scroller {
    margin: 0 12px;
  }
}


.filter-dropdown {
  --button-background-hover: #efefef;
  --filter-arrow-color: var(--text-color);
  --filter-arrow-color-hover: var(--filter-arrow-color);
  --filter-label-min-width: auto;
	flex-basis: 12%;
  height: 100%;
  width: 100%;
  font-size: 14px;

  .filter-style-wrapper {
	display: none;
  }

  svg .dropdown-arrow {
	fill: var(--filter-arrow-color)
  }

  &:hover {
	svg .dropdown-arrow {
	  fill: var(--filter-arrow-color-hover)
	}
  }

  .bp-dropdown__body {
	margin-top: 10px;
	border: var(--button-border);
	border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;
	padding: 6px 10px;
	overflow: auto;

	/* width */
	&::-webkit-scrollbar {
	  width: 8px;
	}

	/* Track */
	&::-webkit-scrollbar-track {
	  //background: #f1f1f1;
	  display: none;
	}

	/* Handle */
	&::-webkit-scrollbar-thumb {
	  background: #888;
	  border-radius: 6px;
	}

	/* Handle on hover */
	&::-webkit-scrollbar-thumb:hover {
	  background: #555;
	}
  }

  .bp-dropdown__btn {
	display: flex;
	align-items: center;
	justify-content: space-between;
	background: var(--button-background);
	color: var(--button-text-color);
	border: 1px solid #AFAFAF;
	border-radius: 4px;
	font-size: 1em;
	padding: 5px 5px 5px 10px;
	height: 100%;
	width: 100%;
	column-gap: 5px;

	text-align: left;

	&:hover, &.bp-dropdown__btn--active {
	  background: var(--button-background-hover);
	  color: var(--button-text-color-hover);
	}

	> span {
	  white-space: nowrap;
	  overflow: hidden;
	  min-width: var(--filter-label-min-width);
	}
  }

}

/* CTC Accordion mode (only used when attrs.view === 'accordion') */
.filter-accordion {
  background: #fff;
  border-bottom: 1px solid #E5E5E5;
}

.filter-accordion__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  user-select: none;
}

.filter-accordion__title {
  font-size: 14px;
  font-weight: 500;
  color: #000;
}

.filter-accordion__icon {
  font-size: 18px;
  line-height: 1;
  color: #000;
}

.filter-accordion__body {

  margin: 0;
  border-top: 0 !important;

}

.filter-accordion__body::before,
.filter-accordion__body::after {
  display: none !important;
}

.filter-accordion__body > * {
  border-top: 0 !important;
}

.brand-virtual {
  display: flex;
  flex-direction: column;
 
}

.brand-search {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #AFAFAF;
  border-radius: 4px;
  font-size: 12px;
}

.brand-scroller {
  height: 260px;
  overflow-y: auto;
}



.brand-scroller :deep(.adv-list > div) {
  margin-top: 0;
}


:deep(.brand-scroller .vue-recycle-scroller__item-wrapper) {
  margin-bottom: 0px;
}


:deep(.brand-scroller .vue-recycle-scroller__item-view) {
  border: none;
 // border-radius: 4px;
}

.filter-accordion__body {
  position: relative;
  display: block;
  width: 100%;

  > .adv-titled-list > div > .adv-list > div > .adv-list-item {
    padding-left: 16px;
  }
}
.filter-accordion.brand {

  .checkbox-label-list-item {
    font-size: 11px;
    padding-left: 14px;
  }

  .checkbox-label-list-item > * {
    font-style: italic;
    color: #666;
  }

  .check-box {
    width: 1em;
    height: 1em;
    border: solid 1px;
    border-radius: 0.2em;
    background: #fff;
  }
}
.filter-accordion.loyalty {

  .checkbox-label-list-item {
    font-size: 11px;
   
  }
 
  .check-box {
    width: 1em;
    height: 1em;
    border: solid 1px;
    border-radius: 0.2em;
    background: #fff;
  }
 
}
.filter-accordion.loyalty {

  .checkbox-label-list-item {
    font-size: 11px;
  }

  .check-box {
    width: 1em;
    height: 1em;
    border: solid 1px;
    border-radius: 0.2em;
    background: #fff;
  }
 
}
.filter-accordion:last-child {
  border-bottom: none;
}
.brand-search-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;

  .brand-search {
    flex: 1;
    min-width: 0; // prevents flex overflow
  }

  .clear-filter-button {
    flex-shrink: 0;
    padding: 4px 6px;
    height: 32px;
    width: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
